import React from 'react';
import { Outlet } from 'react-router-dom';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { ShopFaq } from '@swyftx/features/shop/components';

const ShopLayout: React.FC = () => (
  <FlexLayout
    direction='row'
    spacing={16}
    justifyContent='space-between'
    className='flex-wrap p-16 @container sm:p-24 sm:pr-0'
  >
    <div className='w-full @md:w-[calc(66%-8px)]'>
      <Outlet />
    </div>
    <ShopFaq className='@xs:w-full @md:w-[calc(33%-8px)]' />
  </FlexLayout>
);

export { ShopLayout };
